// // 记录缓存的路由

const state = {
    // KEEP_ALIVE_COMS: ["Home"]
}
const mutations = {
    // // 添加缓存组件
    // ADD_KEEP_ALIVE_COM(state, name) {
    //     if (!state.KEEP_ALIVE_COMS.includes(name)) {
    //         state.KEEP_ALIVE_COMS.push(name)
    //     }
    // },

    // // 删除缓存组件
    // REMOVE_KEEP_ALIVE_COM(state, name) {
    //     if (state.KEEP_ALIVE_COMS.includes(name)) {
    //         state.KEEP_ALIVE_COMS = state.KEEP_ALIVE_COMS.filter(item => item !== name)
    //     }
    //     // state.KEEP_ALIVE_COMS.pop()
    //     console.log(state.KEEP_ALIVE_COMS)
    // },

    // // 重置缓存组件
    // RESET_KEEP_ALIVE_COM(state) {
    //     state.KEEP_ALIVE_COMS = []
    // }
}
const actions = {}
export default {
    state,
    mutations,
    actions
}